import * as React from 'react'
import { PropsWithChildren, ReactElement } from 'react'
import { Avatar, AvatarProps, Tooltip } from '@fluentui/react-components'

type Props = AvatarProps & { tooltip?: boolean }

export default function PersonAvatar(props: PropsWithChildren<Props>): ReactElement {
    const avatarProps = { ...props, tooltip: undefined }

    if (props.tooltip === false) {
        return <Avatar {...avatarProps} />
    }

    return (
        <Tooltip relationship={'label'} content={props.name} withArrow>
            <Avatar {...avatarProps} />
        </Tooltip>
    )
}
